// extracted by mini-css-extract-plugin
export default {"grid":"specification-section_grid__Cj1ab"};